import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

interface Props {
    fileName?: string;
    saving: boolean;
    visible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const ExerciseVideoOverwriteDialog: React.FC<Props> = ({ fileName, saving, visible, onCancel, onConfirm }) => (
    <Dialog maxWidth="xs" open={visible} fullWidth>
        <DialogTitle>
            <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                <WarningAmberRoundedIcon color="error" />
                <Typography sx={{ fontWeight: 700 }} variant="h6">Override Existing Video?</Typography>
            </Box>
        </DialogTitle>
        <DialogContent dividers>
            <Typography sx={{ mb: 2 }} variant="body2">
                A video with this file name already exists in Firebase Storage under /exercises.
            </Typography>
            <Typography sx={{ fontWeight: 700, mb: 2 }} variant="body2">File: {fileName || 'Unknown'}</Typography>
            <Typography color="text.secondary" variant="body2">
                Overriding will replace the existing storage object with the new file and return a fresh video URL.
            </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button color="error" disabled={saving} onClick={onConfirm} variant="contained">
                Override Video
            </Button>
        </DialogActions>
    </Dialog>
);

export default ExerciseVideoOverwriteDialog;